<h1 mat-dialog-title *ngIf="Dialogdata?.Titel !== undefined">
    {{Dialogdata?.Titel}}
</h1>
<div class="wrapper">
    <img [src]="Dialogdata.Url" />
</div>
<mat-dialog-actions>
    <button app-button mat-dialog-close [Inverted]="true">Schließen</button>
</mat-dialog-actions>
